import React from 'react';
import { Link } from 'react-router-dom';
import { FaArrowRight, FaCreditCard } from 'react-icons/fa';
import ProductIcon from './ProductIcon';
import ProductPriceBlock from './ProductPriceBlock';
import { t } from '../utils/i18n';
import { getProductSalePricing } from '../utils/productPricing';

/**
 * Compact card for catalog products with compare-at discount.
 */
export default function SaleProductCard({
  product,
  language,
  productHref,
  checkoutHref,
  showPayNow = false,
  onPayClick,
  onViewClick,
  className = ''
}) {
  const pricing = getProductSalePricing(product);
  if (!pricing.hasDiscount) return null;

  const monthlySuffix = product?.category_slug === 'mantenimiento'
    || product?.category_slug === 'infraestructura'
    || product?.category_slug === 'encaja'
    ? t('landing.productPriceMonthlySuffix', language)
    : '';

  return (
    <article className={`sale-product-card ${className}`.trim()}>
      <div className="sale-product-card-top">
        <ProductIcon
          iconKey={product.icon_key || 'FaBoxOpen'}
          iconColor={product.icon_color || 'amber'}
          size="md"
        />
        <div className="sale-product-card-head">
          <h3 className="sale-product-card-title">{product.name}</h3>
          {product.category_name && (
            <span className="sale-product-card-category">{product.category_name}</span>
          )}
        </div>
      </div>
      <ProductPriceBlock
        product={product}
        language={language}
        monthlySuffix={monthlySuffix}
        variant="compact"
      />
      <div className="sale-product-card-actions">
        {showPayNow && checkoutHref ? (
          <Link
            to={checkoutHref}
            className="sale-product-card-cta sale-product-card-cta-pay"
            onClick={onPayClick}
          >
            <FaCreditCard aria-hidden />
            <span>{t('userAuth.offerPayNow', language)}</span>
          </Link>
        ) : null}
        <Link
          to={productHref}
          className="sale-product-card-cta sale-product-card-cta-view"
          onClick={onViewClick}
        >
          <span>{t('userAuth.viewOffer', language)}</span>
          <FaArrowRight aria-hidden />
        </Link>
      </div>
    </article>
  );
}
